import {
  GET_TICKET_LIST,
  GET_BLOCK_LIST,
  CREATE_TICKET_TEMPLATE,
  DELETE_TICKET_TEMPLATE,
  UPDATE_TICKET_TEMPLATE,
  GET_GENERAL_CONFIG,
  UPDATE_GENERAL_CONFIG,
  GET_CHECKOUT_CONFIG,
  UPDATE_CHECKOUT_CONFIG,
  GET_KEY_STORAGE,
  UPDATE_TERM_POLICY,
  ADD_KEY_STORAGE,
  CHANGE_PASSWORD,
  GET_BUSINESS_WORK_HOUR,
  UPDATE_BUSINESS_WORK_HOUR,
  MOVE_SUBJECT,
  UPDATE_KEY_STORAGE,
  UPDATE_LIST_KEY_STORAGE,
  GET_SMS_CONTENT,
  UPDATE_SMS_CONTENT,
  GET_POLICIES,
  GET_TAX,
  UPDATE_TAX,
  SET_DEFAULT_TICKET_TEMPLATE,
  GET_BOOKING_WORK_HOUR,
  GET_SERVICE_FEE,
  UPDATE_SERVICE_FEE,
  GET_STORE_RATING_DISPLAY,
  UPDATE_STORE_RATING_DISPLAY,
  GET_TIP,
  UPDATE_TIP,
  RELEASE_QR_CODE,
  GET_COUNTRY_CODE, SET_COUNTRY_CODE
} from './appTypes'
import {
  URL_GET_TICKET_LIST, URL_GET_BLOCK_LIST, URL_CREATE_TICKET_TEMPLATE, URL_DELETE_TICKET_TEMPLATE,
  URL_UPDATE_TICKET_TEMPLATE, URL_GET_GENERAL_CONFIG, URL_UPDATE_GENERAL_CONFIG, URL_GET_CHECKOUT_CONFIG,
  URL_UPDATE_CHECKOUT_CONFIG, URL_GET_KEY_STORAGE, URL_UPDATE_TERM_POLICY, URL_ADD_KEY_STORAGE, URL_CHANGE_PASSWORD, URL_GET_TAX,
  URL_GET_BUSINESS_WORK_HOUR, URL_UPDATE_BUSINESS_WORK_HOUR, URL_MOVE_SUBJECT, URL_UPDATE_KEY_STORAGE, URL_UPDATE_LIST_KEY_STORAGE, URL_GET_SMS_CONTENT, URL_UPDATE_SMS_CONTENT, URL_GET_POLICIES, URL_UPDATE_TAX,
  URL_SET_DEFAULT_TICKET_TEMPLATE, URL_GET_SERVICE_FEE, URL_UPDATE_SERVICE_FEE, URL_GET_STORE_RATING_DISPLAY, URL_UPDATE_STORE_RATING_DISPLAY, URL_GET_TIP, URL_UPDATE_TIP, URL_RELEASE_QR_CODE
} from './appUrls'
import { ResponseModel, STATUS_OK } from "../../models/network/response_model";
import axios from '../../axios'
// import domain from '../../axios'
// import baseAxios from "axios";

export default {
  [GET_TICKET_LIST]({ commit }) {
    // let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_TICKET_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_TICKET_LIST, data);
              resolve(data);
            } else {
              commit(GET_TICKET_LIST, {});
              resolve({});
            }
          } else {
            commit(GET_TICKET_LIST, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_BLOCK_LIST]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BLOCK_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BLOCK_LIST, data);
              resolve(data);
            } else {
              commit(GET_BLOCK_LIST, []);
              resolve([]);
            }
          } else {
            commit(GET_BLOCK_LIST, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_GENERAL_CONFIG]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_GENERAL_CONFIG}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_GENERAL_CONFIG, data);
              resolve(data);
            } else {
              commit(GET_GENERAL_CONFIG, {});
              resolve({});
            }
          } else {
            commit(GET_GENERAL_CONFIG, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_GENERAL_CONFIG]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_GENERAL_CONFIG}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_GENERAL_CONFIG)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_CHECKOUT_CONFIG]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_CHECKOUT_CONFIG}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CHECKOUT_CONFIG, data);
              resolve(data);
            } else {
              commit(GET_CHECKOUT_CONFIG, {});
              resolve({});
            }
          } else {
            commit(GET_CHECKOUT_CONFIG, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_CHECKOUT_CONFIG]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_CHECKOUT_CONFIG}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_CHECKOUT_CONFIG)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [GET_KEY_STORAGE]({ commit }, item) {
    // let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      // const axiosInstance = baseAxios.create({ baseURL: domain });
      // axiosInstance.interceptors.request.use(
      //   (config) => {
      //     console.log(JSON.parse(JSON.stringify(config)));
      //     const token = localStorage.getItem('accessToken');
      //     if (token) {
      //       // config.headers.authorization = `Bearer ${token}`;
      //       // config.header['g-clientid'] = localStorage.getItem('domainId');
      //       config.headers = {
      //         'Authorization': `Bearer ${token}`,
      //         'G-ClientID': localStorage.getItem('domainId'),
      //       }
      //     }
      //     console.log(config);
      //     return config;
      //   },
      //   (error) => Promise.reject(error),
      // );
      axios.get(URL_GET_KEY_STORAGE, { params: item })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_KEY_STORAGE, data);
              resolve(data);
            } else {
              commit(GET_KEY_STORAGE, { items: [], _links: {}, _meta: {} });
              reject(resultModel.message)
            }
          } else {
            commit(GET_KEY_STORAGE, { items: [], _links: {}, _meta: {} });
            reject(responseModel.message)
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_COUNTRY_CODE]({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.get(URL_GET_KEY_STORAGE, {
          params: {
            key: 'host.country_code'
          }
        })
        let responseModel = new ResponseModel(response);
        if (responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if (resultModel.status == STATUS_OK) {
            const countryCode = resultModel.data.value;
            commit(SET_COUNTRY_CODE, countryCode);
            resolve(countryCode);
          } else {
            throw new Error(resultModel.message)
          }
        } else {
          throw new Error(responseModel.message)
        }
      } catch(error) {
        reject(error)
      }
    })
  },

  // eslint-disable-next-line
  [UPDATE_TERM_POLICY]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_TERM_POLICY}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_KEY_STORAGE, item)
              dispatch(GET_POLICIES);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [ADD_KEY_STORAGE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_ADD_KEY_STORAGE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_KEY_STORAGE, item)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [CHANGE_PASSWORD]({ }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHANGE_PASSWORD}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CREATE_TICKET_TEMPLATE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CREATE_TICKET_TEMPLATE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // if(item.type) {
              //   let obj = {
              //     type: item.type
              //   }
              //   dispatch(GET_TICKET_LIST, obj);
              // } else {
              dispatch(GET_TICKET_LIST);
              // }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_TICKET_TEMPLATE]({ dispatch }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_TICKET_TEMPLATE}${param}`, data)
        .then((response) => {
          console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // if(item.type) {
              //   let obj = {
              //     type: item.type
              //   }
              //   dispatch(GET_TICKET_LIST, obj);
              // } else {
              dispatch(GET_TICKET_LIST);
              // }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  // [SET_DEFAULT_TICKET_TEMPLATE]({ dispatch }, item) {
  //   // let param = new URLSearchParams(item).toString();
  //   return new Promise((resolve, reject) => {
  //     let data = new FormData();
  //     for (var key in item) {
  //       data.append(key, item[key]);
  //     }
  //     axios.post(`${URL_SET_DEFAULT_TICKET_TEMPLATE}`, data)
  //       .then((response) => {
  //         console.log(response)
  //         let responseModel = new ResponseModel(response);
  //         if (responseModel.status == STATUS_OK) {
  //           let resultModel = responseModel.result;
  //           if (resultModel.status == STATUS_OK) {
  //             let data = resultModel.data;
  //             if(item.type) {
  //               let obj = {
  //                 type: item.type
  //               }
  //               dispatch(GET_TICKET_LIST, obj);
  //             } else {
  //               dispatch(GET_TICKET_LIST);
  //             }
  //             resolve(data);
  //           } else {
  //             reject(resultModel.message);
  //           }
  //         } else {
  //           reject(responseModel.message);
  //         }
  //       })
  //       .catch((error) => { reject(error) });
  //   })
  // },

  [DELETE_TICKET_TEMPLATE]({ dispatch }, item) {
    let param = new URLSearchParams(item)
    return new Promise((resolve, reject) => {
      axios.get(`${URL_DELETE_TICKET_TEMPLATE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // if(item.type) {
              //   let obj = {
              //     type: item.type
              //   }
              //   dispatch(GET_TICKET_LIST, obj);
              // } else {
              dispatch(GET_TICKET_LIST);
              // }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        }).catch(err => reject(err))
    })
  },
  [GET_BUSINESS_WORK_HOUR]({ commit }, item) {
    let param = '';
    if(item) {
      param = new URLSearchParams(item).toString();
    }
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BUSINESS_WORK_HOUR}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BUSINESS_WORK_HOUR, data);
              resolve(data);
            } else {
              commit(GET_BUSINESS_WORK_HOUR, {});
              resolve({});
            }
          } else {
            commit(GET_BUSINESS_WORK_HOUR, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_BUSINESS_WORK_HOUR]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_BUSINESS_WORK_HOUR}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_BUSINESS_WORK_HOUR)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  [GET_BOOKING_WORK_HOUR]({ commit }, item) {
    let param = '';
    if(item) {
      param = new URLSearchParams(item).toString();
    }
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_BUSINESS_WORK_HOUR}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_BOOKING_WORK_HOUR, data);
              resolve(data);
            } else {
              commit(GET_BOOKING_WORK_HOUR, {});
              resolve({});
            }
          } else {
            commit(GET_BUSINESS_WORK_HOUR, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [MOVE_SUBJECT]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_MOVE_SUBJECT}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // if(item.type) {
              //   let obj = {
              //     type: item.type
              //   }
              //   dispatch(GET_TICKET_LIST, obj);
              // } else {
              dispatch(GET_TICKET_LIST);
              // }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [UPDATE_KEY_STORAGE]({ }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_UPDATE_KEY_STORAGE, data).then((response) => {
        let responseModel = new ResponseModel(response);
        if (responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if (resultModel.status == STATUS_OK) {
            resolve();
          } else {
            reject(resultModel.message);
          }
        } else {
          reject(responseModel.message);
        }
      }).catch(error => reject(error));
    })
  },
  // eslint-disable-next-line
  [UPDATE_LIST_KEY_STORAGE]({ }, data) {
    return new Promise((resolve, reject) => {
      axios.post(URL_UPDATE_LIST_KEY_STORAGE, data).then((response) => {
        let responseModel = new ResponseModel(response);
        if (responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if (resultModel.status == STATUS_OK) {
            resolve();
          } else {
            reject(resultModel.message);
          }
        } else {
          reject(responseModel.message);
        }
      }).catch(error => reject(error));
    })
  },
  [GET_SMS_CONTENT]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SMS_CONTENT}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SMS_CONTENT, data);
              resolve(data);
            } else {
              commit(GET_SMS_CONTENT, {});
              resolve({});
            }
          } else {
            commit(GET_SMS_CONTENT, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_SMS_CONTENT]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(URL_UPDATE_SMS_CONTENT, data).then((response) => {
        let responseModel = new ResponseModel(response);
        if (responseModel.status == STATUS_OK) {
          let resultModel = responseModel.result;
          if (resultModel.status == STATUS_OK) {
            let data = resultModel.data;
            dispatch(GET_SMS_CONTENT);
            resolve(data);
          } else {
            reject(resultModel.message);
          }
        } else {
          reject(responseModel.message);
        }
      }).catch(error => reject(error));
    })
  },
  [GET_POLICIES]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_POLICIES}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_POLICIES, data);
              resolve(data);
            } else {
              commit(GET_POLICIES, []);
              resolve([]);
            }
          } else {
            commit(GET_POLICIES, []);
            resolve([]);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [SET_DEFAULT_TICKET_TEMPLATE]({ dispatch }, item) {
    // let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${ URL_SET_DEFAULT_TICKET_TEMPLATE }`, data)
        .then((response) => {
          console.log(response)
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              if (item.type) {
                let obj = {
                  type: item.type
                }
                dispatch(GET_TICKET_LIST, obj);
              } else {
                dispatch(GET_TICKET_LIST);
              }
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  [GET_TAX]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${ URL_GET_TAX }`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_TAX, data);
              resolve(data);
            } else {
              commit(GET_TAX, {});
              resolve({});
            }
          } else {
            commit(GET_TAX, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_TAX]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${ URL_UPDATE_TAX }`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_TAX)
              resolve(data);
            } else {
              reject(resultModel.message[0].value[0]);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  [GET_TIP]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${ URL_GET_TIP }`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_TIP, data);
              resolve(data);
            } else {
              commit(GET_TIP, {});
              resolve({});
            }
          } else {
            commit(GET_TIP, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_TIP]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`${ URL_UPDATE_TIP }`, item)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_TIP)
              resolve(data);
            } else {
              reject(resultModel.message[0].value[0]);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  [GET_SERVICE_FEE]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${ URL_GET_SERVICE_FEE }`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SERVICE_FEE, data);
              resolve(data);
            } else {
              commit(GET_SERVICE_FEE, {});
              resolve({});
            }
          } else {
            commit(GET_SERVICE_FEE, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_SERVICE_FEE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${ URL_UPDATE_SERVICE_FEE }`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_SERVICE_FEE)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  [GET_STORE_RATING_DISPLAY]({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${ URL_GET_STORE_RATING_DISPLAY }`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STORE_RATING_DISPLAY, data);
              resolve(data);
            } else {
              commit(GET_STORE_RATING_DISPLAY, {});
              resolve({});
            }
          } else {
            commit(GET_STORE_RATING_DISPLAY, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  [UPDATE_STORE_RATING_DISPLAY]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${ URL_UPDATE_STORE_RATING_DISPLAY }`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_STORE_RATING_DISPLAY)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  [RELEASE_QR_CODE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_RELEASE_QR_CODE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
}
